<template>
    <div>
        <Card shadow>
            <Row :gutter="18">
                <Col span="7" style="display:none">
                    <label style="display: flex; align-items: center">
                        <span style="width: 120px">筛选时间:</span>
                        <DatePicker type="daterange" v-model="dataTime" placeholder="信息筛选时间" :options="dateOptions" :clearable="false"></DatePicker>
                    </label>
                </Col>
                <Col span="3">
                    <label style="display: flex; align-items: center">
                        <span style="width: 80px">代理组:</span>
                        <Select v-model="table.params.platid" filterable placeholder="选择APP分组" @on-change="GetAbnormalTypeList">
                            <Option v-for="(item, index) in plat_list" :value="item.id" :label="item.name" :key="index">
                                {{ item.name }}
                                <span style="color: #bbb">({{ item.id }})</span>
                            </Option>
                        </Select>
                    </label>
                </Col>
                <Col span="5">
                    <label style="display: flex; align-items: center">
                        <span style="width: 50px">代理:</span>
                        <Select v-model="table.params.app_id" filterable placeholder="选择APP盘口" :max-tag-count="3" clearable>
                            <Option v-for="(item, index) in app_list.filter((item) => item.platform == table.params.platid)" :value="item.appid" :label="item.appName" :key="index">
                                {{ item.appName }}
                                <span style="color: #bbb">({{ item.appid }})</span>
                            </Option>
                        </Select>
                    </label>
                </Col>
                <Col span="3">
                    <label style="display: flex; align-items: center">
                        <span style="width: 120px">异常类型:</span>
                        <Select v-model="table.params.atype" filterable placeholder="筛选 异常类型" clearable>
                            <Option v-for="(item, index) in atypeList" :value="item.value" :label="item.name" :key="index">
                                {{ item.name }}
                            </Option>
                        </Select>
                    </label>
                </Col>
                <Col span="3">
                    <label style="display: flex; align-items: center">
                        <span style="width: 130px">玩家UID:</span>
                        <Input v-model="table.params.uid" placeholder="筛选 玩家UID" clearable></Input>
                    </label>
                </Col>
                <Col span="3">
                    <label style="display: flex; align-items: center">
                        <span style="width: 210px">异常原因关键字:</span>
                        <Input v-model="table.params.reason" placeholder="筛选 异常原因关键字" clearable></Input>
                    </label>
                </Col>
                <Col span="4">
                    <Button type="primary" @click="SearchAbnormalList(1)" style="margin-right: 12px" :disabled="!table.params.platid">查询</Button>
                    <Button type="primary" @click="RefreshAbnormalList(1)" style="">刷新</Button>
                </Col>
            </Row>
        </Card>
        <Table border :columns="table.columns" :data="table.data" style="margin-top: 10px" :max-height="650" @on-selection-change="selectChange"></Table>
        <Page show-total style="margin-top: 10px" :current="table.params.page" :total="table.total" :page-size-opts="table.pageSizes" :page-size="table.params.page_size" show-sizer @on-page-size-change="limitchange" @on-change="pagechange"></Page>
        <Button type="warning" @click="DelAbnormalManyList()" style="margin-top: 10px" :disabled="currentSelectItem.length == 0">批量删除</Button>
    </div>
</template>
<script>
import { TransTopReq } from '@/api/admin/risk'
export default {
    name: 'abnormalPlayerConf',
    data() {
        return {
            currentSearch: {
                platid: 0,
                app_id: 0
            },
            dataTime: [new Date(), new Date()],
            currentSelectItem: [],
            table: {
                params: { platid: 0, app_id: 0, page_size: 10, page: 1 },
                pageSizes: [10, 20, 30, 40],
                total: 0,
                data: [],
                columns: [
                    { type: 'selection', width: 50, align: 'center', fixed: 'left' },
                    { title: '玩家UID', key: 'uid', width: 100, align: 'center' },
                    {
                        title: '所属平台',
                        key: 'platid',
                        minWidth: 100,
                        align: 'center',
                        render: (h, params) => {
                            let find = this.plat_list.find((el) => el.id == params.row.platid)
                            return h('div', [h('span', find ? find.name : ''), h('span', { style: 'color:#bbb' }, `(${params.row.platid})`)])
                        }
                    },
                    {
                        title: '所属App',
                        key: 'app_id',
                        minWidth: 100,
                        align: 'center',
                        render: (h, params) => {
                            let find = this.app_list.find((el) => el.appid == params.row.app_id)
                            return h('div', [h('span', find ? find.appName : ''), h('span', { style: 'color:#bbb' }, `(${params.row.app_id})`)])
                        }
                    },
                    {
                        title: '异常类型',
                        key: 'atype',
                        minWidth: 100,
                        align: 'center',
                        render: (h, params) => h('span', this.atypeMap[params.row.atype] || '')
                    },
                    { title: '异常原因', key: 'reason', minWidth: 250, align: 'center' },
                    { title: '创建时间', key: 'ctime', minWidth: 130, align: 'center' },
                    { title: '更新时间', key: 'utime', minWidth: 130, align: 'center' },
                    { title: '过期时间', key: 'expire', minWidth: 130, align: 'center' },
                    {
                        title: '管理',
                        key: 'options',
                        minWidth: 100,
                        fixed: 'right',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h(
                                    'Button',
                                    {
                                        props: { type: 'error' },
                                        on: {
                                            click: () => {
                                                this.$Modal.confirm({
                                                    title: '删除异常玩家',
                                                    content: '是否确认删除异常玩家:' + params.row.uid,
                                                    onOk: () => {
                                                        let item = { platid: params.row.platid, app_id: params.row.app_id, ids: [params.row.id] }
                                                        this.DelAbnormalList(item)
                                                    }
                                                })
                                            }
                                        }
                                    },
                                    '删除'
                                )
                            ])
                        }
                    }
                ]
            },
            atypeList: [],
            atypeMap: {}
        }
    },
    methods: {
        selectChange(selection) {
            this.currentSelectItem = [...selection]
        },
        DelAbnormalManyList() {
            if (this.currentSelectItem.length > 0) {
                let str = this.currentSelectItem.map((item) => item.uid).join('、')
                this.$Modal.confirm({
                    title: '批量删除',
                    content: '是否确认删除: ' + str,
                    onOk: () => {
                        let params = {
                            platid: this.currentSearch.platid,
                            app_id: this.currentSearch.app_id,
                            ids: this.currentSelectItem.map((item) => item.id) || []
                        }
                        this.DelAbnormalList(params)
                    }
                })
            }
        },
        returnParam(func, _param) {
            return {
                mod: 'root',
                platid: _param.platid,
                app_id: _param.app_id,
                param: {
                    _mod: 'root',
                    _func: func,
                    _param: { ..._param }
                }
            }
        },
        SearchAbnormalList(num) {
            if (num) {
                this.table.params.page = 1
            }
            let params = { ...this.table.params }
            params.uid = Number(params.uid) || 0
            params.stime = this.getSecond(this.dataTime[0])
            params.etime = this.getSecond(this.dataTime[1], false)
            this.currentSearch = { ...params }
            this.currentSelectItem = []
            TransTopReq(this.returnParam('SearchAbnormalList', params)).then((res) => {
                this.table.data = res._param.list || []
                this.table.total = res._param.total
            })
        },
        limitchange(page_size) {
            this.table.params.page_size = page_size
            this.table.params.page = 1
            this.SearchAbnormalList()
        },
        pagechange(page) {
            this.table.params.page = page
            this.SearchAbnormalList()
        },
        RefreshAbnormalList() {
            let params = { ...this.table.params }
            TransTopReq(this.returnParam('RefreshAbnormalList', params)).then((res) => {
                this.SearchAbnormalList(1)
            })
        },
        DelAbnormalList(params) {
            TransTopReq(this.returnParam('DelAbnormalList', params)).then((res) => {
                this.$Message.success('操作成功')
                this.SearchAbnormalList(1)
            })
        },
        initFunc() {
            this.table.params.platid = this.getinitPlatId()
            this.table.params.app_id = this.app_list.filter((item) => item.platform == this.table.params.platid)[0]['appid']
            this.SearchAbnormalList()
            this.GetAbnormalTypeList()
        },
        GetAbnormalTypeList() {
            let param = {
                platid: this.table.params.platid,
                app_id: this.table.params.app_id
            }
            TransTopReq(this.returnParam('AbnormalTypeList', param)).then((res) => {
                this.atypeMap = res._param.list || {}
                let arr = []
                for (let i in this.atypeMap) {
                    arr.push({
                        value: Number(i),
                        name: this.atypeMap[i]
                    })
                }
                this.atypeList = arr
            })
        }
    },

    created() {
        this.initFunc()
        //获取报警数据类型
    }
}
</script>
<style lang="less" scoped>
.btn_batch {
    margin-right: 12px;
}
</style>
